// Domain-aware locale configuration.
// ⚠️ Один общий Vue-билд обслуживает несколько доменов (см. deploy-all.sh).
// Набор языков и дефолт различаются по тенанту (домену) — здесь единый источник.
//
// Правила:
//  - BR-тенант (clipcutbr.com / app.clipcutbr.com): дефолт PT, доступны [pt, en],
//    русский СКРЫТ, fallback = en (дыры перевода показывают английский, не русский).
//  - Все остальные (существующие) домены: дефолт RU, доступны [ru, en] — без изменений.

const LANG_META = {
  ru: { code: 'ru', label: 'RU', icon: 'bi bi-globe' },
  en: { code: 'en', label: 'EN', icon: 'bi bi-globe2' },
  pt: { code: 'pt', label: 'PT', icon: 'bi bi-globe2' },
};

function hostname() {
  return (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
}

// Локальная/preview-проверка BR без реального домена: ?locale_tenant=br
function forcedTenant() {
  if (typeof window === 'undefined' || !window.location) return '';
  try {
    return new URLSearchParams(window.location.search).get('locale_tenant') || '';
  } catch (e) {
    return '';
  }
}

export function isBrTenant() {
  if (forcedTenant() === 'br') return true;
  const host = hostname();
  return host === 'clipcutbr.com' || host.endsWith('.clipcutbr.com');
}

export function getTenantLocaleConfig() {
  if (isBrTenant()) {
    return { default: 'pt', available: ['pt', 'en'], fallback: 'en' };
  }
  return { default: 'ru', available: ['ru', 'en'], fallback: 'ru' };
}

// Языки для свитчеров — с метаданными (label/icon), в порядке из available.
export function getAvailableLanguages() {
  return getTenantLocaleConfig().available.map((code) => LANG_META[code]);
}

// Стартовая локаль: сохранённая пользователем — только если валидна для ЭТОГО тенанта
// (иначе, напр., 'ru' из другого домена не должен протечь на BR). Иначе — дефолт тенанта.
export function resolveInitialLocale() {
  const cfg = getTenantLocaleConfig();
  let saved = '';
  try {
    saved = (typeof localStorage !== 'undefined' && localStorage.getItem('user-locale')) || '';
  } catch (e) {
    saved = '';
  }
  if (saved && cfg.available.includes(saved)) return saved;
  return cfg.default;
}
